import React from "react";
import { makeStyles } from "@material-ui/styles";
import { Typography } from "@material-ui/core";
import StyledButton from "../components/StyledButton";

const useStyles = makeStyles({
  card: {
    background: "url(/images/student_footer.jpg) no-repeat center center",
    backgroundSize: "cover",
    width: "100%",
    position: "relative",
    "&::before": {
      content: '""',
      position: "absolute",
      width: "100%",
      height: "100%",
      top: 0,
      background: "#35C974",
      opacity: 0.7,
    },
  },
  content: {
    position: "relative",
    padding: "10vw 8vw",
    color: "white",
  },

  "@media (max-width: 720px)": {
    content: {
      position: "relative",
      padding: "8vw 6vw",
      color: "white",
      textAlign: "center",
    },
    title: {
      fontSize: 24,

      textAlign: "center",
    },
    description: {
      fontSize: 18,

      textAlign: "center",
    },
  },
});

export default function TeacherJoin() {
  const classes = useStyles();
  return (
    <section>
      <div className={classes.card}>
        <div className={classes.content}>
          <Typography variant="h5" className={classes.accent} color="secondary">
            به عنوان معلم زبان
          </Typography>
          <br />
          <Typography variant="h3" className={classes.title}>
            استاد زبان لینگوتاک شوید!
          </Typography>
          <br />
          <Typography variant="h4" className={classes.description}>
            با برنامه‌ی زمانی و قیمت دلخواه خود، تدریس آنلاین زبان را شروع کنید.
          </Typography>
          <br />
          <StyledButton size="large" variant="contained" color="secondary">
            <a
              style={{
                height: "100%",
                width: "100%",
                color: "white",
                textDecoration: "none",
              }}
              id="join-teacher-btn"
              href="/joinTeacher"
            >
              به لینگوتاک بپیوندید
            </a>
          </StyledButton>
        </div>
      </div>
    </section>
  );
}
